/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import genericLogo from '@/assets/digital.png'
import tulipLogo from '@/assets/tulip/tulip_logo.png'

function MesBottomNode({ data, isConnectable }) {
  const mesLogo = () => {
    const demoEnv = localStorage.getItem('TARGET')
    if (demoEnv === 'MSFT') {
      return tulipLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'AWS') {
      return tulipLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'GCP') {
      return tulipLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else {
      return tulipLogo
    }
  }
  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={mesLogo()} alt="MES Logo" className="custom-node-plc-logo" />
          </div>
          <div className="text-center">
            <b>MES</b>
          </div>
        </div>
      </div>

      <Handle type="target" position={Position.Bottom} />
      <Handle type="source" position={Position.Bottom} />
    </div>
  )
}

export default MesBottomNode
